import { Component, OnInit } from '@angular/core';
import { CustomDashboardsService } from 'app/modules/my-limegear/services/my-limegear.service';
import { PerformanceService } from 'app/modules/performance/services/performance.service';
import { ReusableFunctions } from 'app/modules/shared/classes/reusable-functions';
import { NoDataActionType } from 'app/modules/shared/interfaces/no-data';
import { ICardInfo } from '../../interfaces/stanalone-components.data';
import { LargeCardService } from '../../services/large-card.service';

@Component({
    selector: 'app-performance-projections-actual-lgc',
    templateUrl: './performance-projections-actual-lgc.component.html',
    styleUrls: ['./performance-projections-actual-lgc.component.scss'],
})
export class PerformanceProjectionsActualLgcComponent implements OnInit {
    action: NoDataActionType;
    chartCardInfo: ICardInfo;
    cardDrilldownUrl = '/reporting/performance/';
    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private performanceService: PerformanceService
    ) {}

    ngOnInit() {
        this.action = NoDataActionType.pageStart;
        this.chartCardInfo = {
            cardId: 'performance-projections-actual',
            drilldownSegment: 'projectionsYTDActuals',
            title: 'Projections to YTD Actuals',
            cardTitle: 'Projections to YTD Actuals',
            hasData: false,
            routerPath: this.cardDrilldownUrl,
            dataTableData: [],
            searchTerm: '',
            action: this.action,
            outerTableHeight: '430px',
            hideViewAll: true,
            showCardControllers: true,
        };
    }

    ngAfterViewInit() {
        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this.performanceService.setPerformanceAAGData(
                changes.displayOptions,
                changes.hierarchyfilters,
                this.chartCardInfo,
                changes.action,
                true
            );
        });
    }
}
